const LoadingIndicator = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingIndicator;
